'use client';

import { useEffect } from 'react';

import { cleanupLegacyAuthCookies } from './shared/lib/legacy-auth-cleanup';
import { isCognitoEnabled } from './shared/lib/env';

export default function LegacyAuthCleanupClient() {
  useEffect(() => {
    if (!isCognitoEnabled) return;

    const cleared = cleanupLegacyAuthCookies();
    if (cleared.length > 0) {
      // eslint-disable-next-line no-console
      console.info(
        '[auth] cleared legacy pre-Cognito cookies:',
        cleared.join(', '),
      );
    }
  }, []);

  return null;
}
